import React from 'react';

import { Button } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';
import { isWeb } from 'utils/environment';

export const Title = withTypography({ bold: true, textAlign: 'center', fontSize: 'xs' });

export const TitlePointDivider = withTypography({
  fontSize: 'xl',
  style: { paddingTop: isWeb ? undefined : spacing.$1 },
});

export const DescriptionPart = withTypography({
  style: { paddingTop: isWeb ? undefined : spacing.$0_5 },
});

type ContainerProps = BoxProps & { hasTitle?: boolean };

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: spacing.$0_5,
    paddingBottom: spacing.$1_5,
  },
  containerWithTitle: {
    paddingBottom: 0,
  },
  desktopContainer: {
    borderBottomColor: primitive.$blackOpacity10,
    borderBottomWidth: 1,
  },
  modalBodyContainer: {
    maxWidth: 320,
  },
  modalItemContainer: {
    marginTop: spacing.$4,
  },
  modalSubtitleContainer: {
    flexDirection: 'row',
  },
});

export const Container = ({ hasTitle, style, ...props }: ContainerProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.container, hasTitle && styles.containerWithTitle, style],
  });

export const ModalBodyContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.modalBodyContainer, style] });

export const ModalItemContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.modalItemContainer, style] });

export const ModalSubtitleContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.modalSubtitleContainer, style] });

export const IconContainer = Button.withConfig({
  variant: 'ghost',
  padding: '$1',
});

export const DesktopContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.desktopContainer, style] });
